<template>

	<div class="backgroundClass">
		<div class="waititle" style="font-weight: bold;margin-top: -40px;">
			<div class="blue" />
			添加劵/劵包
		</div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>劵设置
		</div>
		<div class="first_line">
			<div class="right_warp">
				<!-- 选择门店 -->
				<el-select class="jul" size="small" v-model="query.status" placeholder="全部状态">
					<el-option v-for="item in storeval" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<!-- 选择状态 -->
				<el-select class="jul" size="small" v-model="query.type" placeholder="全部类型">
					<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input clearable size="small" style="text-align: left" class="jul"
					@keydown.enter.native="getCouponList()" placeholder="请输入优惠券名称" v-model="query.name"
					clearable></el-input>
				<el-button class="jul" type="primary" size="small" @click="getCouponList()">筛选</el-button>
				<el-button @click="sendDialog=true" size="small">发券包</el-button>
			</div>
			<div class="addj">
				<el-button type="primary" @click="jump()" size="small" style="left: 5px;">新增优惠券</el-button>
			</div>
		</div>
		<el-tabs type="border-card" v-model="query.overStatus" @tab-click="pagechange()" >
			<el-tab-pane label="进行中" name="1">
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponList" tooltip-effect="dark" style="width: 100%"height="70vh" >
					<el-table-column prop="id" label="券ID" width="80"></el-table-column>
					<el-table-column align="center" prop="title" label="名称" width="100px"></el-table-column>
					<el-table-column prop="couponType" label="类型" width="80"></el-table-column>
					<el-table-column prop="storeName" label="适用范围" width="150px">
						<template slot-scope="scope">
							<div style="overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
								{{scope.row.storeName==null?'全部门店':scope.row.storeName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="superposition" label="叠加" width="120px">
						<template slot-scope="scope">
							{{scope.row.superposition==0?'不可叠加':'可叠加'}}
						</template>
					</el-table-column>
					<!-- 	<el-table-column prop="buyNum" label="购买价格"  width="100">
							<template slot-scope="scope">
								{{scope.row.buyNum == null ? 0 : scope.row.buyNum}}元
							</template>
						</el-table-column> -->
					<el-table-column prop="content" label="劵内容">
						<template slot-scope="scope">
							<div style="text-overflow:ellipsis;">
								<p v-html='scope.row.content'></p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="remark" label="备注"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期" width="175"></el-table-column>
					<el-table-column prop="getNumScaleTotalNum" label="券库存" width="120">
						<template slot-scope="scope">
							<el-progress :percentage="scope.row.percentage" :color="customColors" :stroke-width="22"
								:text-inside="true"></el-progress>
						</template>
					</el-table-column>
					<el-table-column prop="totalNum" label="券总量" width="70">
						<template slot-scope="scope">
							{{scope.row.totalNum}}张
						</template>
					</el-table-column>
					<el-table-column prop="getNum" label="已领取" width="70">
						<template slot-scope="scope">
							{{scope.row.getNum}}张
						</template>
					</el-table-column>
					<el-table-column prop="useNum" label="已使用" width="70">
						<template slot-scope="scope">
							{{scope.row.useNum}}张
						</template>
					</el-table-column>
					<el-table-column width="175" label="操作" align="right">
						<template slot-scope="scope">
							<div>{{ scope.row.status==1?"进行中":""}}</div>
							<div>{{ scope.row.status==2?"已停止":""}}</div>
							<div>{{ scope.row.status==3?"已结束":""}}</div>
							<div>{{ scope.row.status==4?"已失效":""}}</div>
							<div>
								<el-button type="text" @click="pushjuan(scope.row.id)">定向发送</el-button>
							</div>
							<div>
								<el-button type="text" @click="deit(scope.row.id)">编辑</el-button>
								<!-- <el-button type="text" @click="dialog_tuig = true">推广</el-button> -->
								<el-button type="text" @click="updateStatus(scope.row.id)">
									{{ scope.row.status == '1' ?'停止' :'开始' }}</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagescg">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="query.total">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="已过期" name="2">
				<div>
					<el-table :header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
						:data="couponList" tooltip-effect="dark" style="width: 100%">
						<el-table-column prop="id" label="卷ID"></el-table-column>
						<el-table-column align="center" prop="title" label="名称"></el-table-column>
						<el-table-column prop="couponType" label="类型"></el-table-column>
						<el-table-column prop="storeListName" label="适用范围"></el-table-column>
						<el-table-column prop="content" label="卷内容"></el-table-column>
						<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
						<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
						<el-table-column prop="useNum" label="已使用"></el-table-column>
						<el-table-column width="175" label="操作" align="right">
							<template slot-scope="scope">
								<div>已过期</div>
								<div>
									<el-button type="text">效果数据</el-button>
								</div>
								<div>
									<el-button type="text" @click="deletejuan(scope.row.id)"><span
											style="color: red;">删除</span></el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagescg">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
							layout="total, sizes, prev, pager, next, jumper" :total="query.total">
						</el-pagination>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!-- 推广 -->
		<el-dialog :visible.sync="dialog_tuig" width="25%">
			<div class="dia_title">优惠券H5</div>
			<div class="erwei">
				<img src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393" />
			</div>
			<div>
				<div class="downerwei" @click="downloadCodeImg(img)">
					下载二维码
				</div>
			</div>
			<section class="form">
				<el-input :disabled="true" size="small" v-model="cjurl" style="width: 252px;margin-left:50px;margin-top: 20px;
						margin-bottom:30px;"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" v-clipboard:copy="cjurl" v-clipboard:success="onCopy"
						v-clipboard:error="onError" @click="dialog_tuig = copy">复
						制</el-button>
				</span>
			</section>
		</el-dialog>
		<!-- 定向投放 -->
		<el-dialog :visible.sync="dialog_touf" width="30%">
			<div class="title" style="margin-top:-43px;">
				<div class="blue"></div>
				<div style="flex: 1;">运营计划管理</div>
			</div>
			<el-form label-width="80px">
				<el-form-item label="选择用户">
					<el-radio v-model="chooseruser" label="0">全部用户</el-radio>
					<el-radio v-model="chooseruser" label="1">指定用户群体</el-radio>
				</el-form-item>
				<el-form-item label="选择用户" v-if="chooseruser==1">
					<div class="boton">
						<div class="boton1">
							<div class="boton1_title" @click="dialog_shangzhi=true">+添加商品用户</div>
							<div class="botonlist">
								高活跃用户
								<div @click="clear_bon">×</div>
							</div>
						</div>
						<div class="boton1">
							<div class="boton1_title" @click="dialog_user=true">+指定用户群</div>
							<div class="botonlist">
								高活跃用户
								<div @click="clear_bon">×</div>
							</div>
						</div>
						<div class="duo">
							可多选
						</div>
					</div>
				</el-form-item>
				<el-form-item label="推送时间">
					<div class="bon_data">
						<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" size="small" v-model="time1" type="datetime"
							placeholder="选择日期时间">
						</el-date-picker>
					</div>
					<div class="lastbottom">
						<el-button size="small" @click="dialog_touf=false">取 消</el-button>
						<el-button type="primary" size="small" @click="timepush">确 定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 定向投放 -->
		<div class="lastdig">
			<el-dialog :visible.sync="dialog_user" width="50%">
				<div class="tanchutitle">添加用户群</div>
				<el-table :height="300" :data="tableData_1" style="width: 100%">
					<el-table-column prop="date" label="选择">
						<template slot-scope="scope">
							<el-checkbox :key="scope.row.id"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="群名称">
					</el-table-column>
				</el-table>
				<div class="lastbottom" style="margin-left: 38%;">
					<el-button size="small" @click="dialog_user=false">取 消</el-button>
					<el-button type="primary" size="small">确 定</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 添加商品用户/指定用户 -->
		<div class="lastdig">
			<el-dialog :visible.sync="dialog_shangzhi" width="40%">
				<div style="margin-top: -40px;">
					<el-tabs type="card">
						<el-tab-pane label="剪发服务">
							<el-checkbox-group v-model="checkList">
								<el-table :height="300" :data="tableData_1" style="width: 100%">
									<el-table-column prop="date" label="选择">
										<template slot-scope="scope">
											<el-checkbox :key="scope.row.id"></el-checkbox>
										</template>
									</el-table-column>
									<el-table-column prop="name" label="姓名">
									</el-table-column>
									<el-table-column prop="address" label="地址">
									</el-table-column>
								</el-table>
							</el-checkbox-group>
						</el-tab-pane>
						<el-tab-pane label="商城商品">
							<el-table :height="300" :data="tableData_1" style="width: 100%">
								<el-table-column prop="date" label="选择">
									<template slot-scope="scope">
										<el-checkbox :key="scope.row.id"></el-checkbox>
									</template>
								</el-table-column>
								<el-table-column prop="name" label="姓名">
								</el-table-column>
								<el-table-column prop="address" label="地址">
								</el-table-column>
							</el-table>
						</el-tab-pane>
						<el-tab-pane label="会员">
							<el-table :height="300" :data="tableData_1" style="width: 100%">
								<el-table-column prop="date" label="选择">
									<template slot-scope="scope">
										<el-checkbox :key="scope.row.id"></el-checkbox>
									</template>
								</el-table-column>
								<el-table-column prop="name" label="姓名">
								</el-table-column>
								<el-table-column prop="address" label="地址">
								</el-table-column>
							</el-table>
						</el-tab-pane>
					</el-tabs>
				</div>
				<div class="mybotton">
					<el-button size="small" @click="dialog_shangzhi=false">取消</el-button>
					<el-button type="primary" size="small">保存</el-button>
				</div>
			</el-dialog>
		</div>
		<el-dialog :visible.sync="sendDialog" width="30%" title="发送权益券包(不包括会员)">
			<el-form label-width="80px" label-position="left">
				<el-form-item label="用户id:"><el-input v-model="sendCouponObject.userId"
						style="width: 216px;"></el-input></el-form-item>
				<el-form-item label="订单id:"><el-input v-model="sendCouponObject.text"
						style="width: 216px;"></el-input></el-form-item>
				<el-form-item label="选择权益">
					<el-select v-model="sendCouponObject.memberId">
						<el-option v-for="item in memberDetail" :key="item.id" :value="item.id"
							:label="item.name + ':' + item.title"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div style="height: 30px;">
				<el-button @click="sendCoupon()" type="primary" style="float: right;">发送</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				pushid: "",
				sendDialog: false,
				query: {
					overStatus: "1",
					name: "",
					status: -1,
					type: -1,
					page: 1,
					size: 10,
					total: 0,
				},
				dialog_user: false,
				// 推广页面
				dialog_tuig: false,
				cjurl: "https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393",
				img: 'https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393',
				// 定向投放
				dialog_touf: false,
				chooseruser: "",
				time1: "",
				//添加商品用户
				dialog_shangzhi: false,
				couponList: [],
				storeval: [{
					label: "全部状态",
					value: -1,
				}, {
					label: "未开始",
					value: 0,
				}, {
					label: "进行中",
					value: 1,
				}, {
					label: "已开始",
					value: 2,
				}, {
					label: "已经失效",
					value: 3,
				}],
				statelist: [{
					label: "全部类型",
					value: -1,
				}, {
					label: "满减卷",
					value: 0,
				}, {
					label: "折扣卷",
					value: 1,
				}, {
					label: "商品卷",
					value: 2,
				}, {
					label: "积分卷",
					value: 3,
				}, {
					label: "第三方",
					value: 4,
				}, {
					label: "膨胀券",
					value: 5,
				}, ],
				memberDetail: [],
				sendCouponObject: {
					userId: '',
					memberId: '',
				},
				tableData_1: [],
				checkList: [],
				customColors: [{
					color: '#f54343',
					percentage: 20
				}, {
					color: '#dea532',
					percentage: 40
				}, {
					color: '#3092fa',
					percentage: 60
				}, {
					color: '#31c12c',
					percentage: 80
				}, ] //进度条颜色
			};
		},
		mounted() {
			this.getCouponList();
			this.getMemberDetail();
			this.checkCouponCode();
		},
		filter: {
			memberFormat(val) {
				switch (val) {
					case 1:
						return "老";
					case 2:
						return "新";
					default:
						return "全部";
				}
			}
		},
		methods: {
			//打开定向发送弹窗
			pushjuan(id) {
				this.pushid = id
				this.dialog_touf = true
			},
			openOutsideCode(coupon) {
				this.uploadOutsideCodes = coupon;
				this.codes = "",
					this.outsideCodeShow = true;
			},
			//定向发送
			timepush() {
				let arr = {}
				arr.couponId = this.pushid
				if (!this.chooseruser) {
					this.$message.error("请选择用户")
					return false
				}
				arr.type = this.chooseruser
				if (!this.time1) {
					this.$message.error("请选择时间")
					return false
				}
				arr.pushTime = this.time1
				this.$http.post("dCoupon/pushUserCouponCode", JSON.stringify(arr)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("添加计划成功")
						this.chooseruser = ""
						this.time1 = ""
						this.dialog_touf = false
					} else {
						this.$message.error(res.body.msg)
					}
				}, err => {
					this.$message.error("请求失败")
				})
			},
			deletejuan(id) {
				alert(id)
			},
			deit(id) {
				this.$router.push({
					path: 'newvolumeset',
					query: {
						id: id
					}
				})
			},
			clear_bon() {
				this.$confirm('是否要删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				});
			},
			//复制路径
			onCopy() {
				this.$message({
					message: `复制成功！`,
					type: 'success'
				});
				this.snackBar.info(this.$t('prompt.copySuccess'))
			},
			onError() {
				this.$message.error(this.$t('prompt.copyFail'))
			},
			// 下载图片
			downloadCodeImg(img) {
				var image = new Image();
				image.setAttribute("crossOrigin", "anonymous");
				var _this = this;
				image.onload = function() {
					var canvas = document.createElement("canvas");
					canvas.width = image.width;
					canvas.height = image.height;
					var context = canvas.getContext("2d");
					context.drawImage(image, 0, 0, image.width, image.height);
					var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
					var a = document.createElement("a"); // 生成一个a元素
					var event = new MouseEvent("click"); // 创建一个单击事件
					a.download = _this.projectName || "photo"; // 设置图片名称
					a.href = url; // 将生成的URL设置为a.href属性
					a.dispatchEvent(event); // 触发a的单击事件
				};
				image.src = img;
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getCouponList();
			},
			handleCurrentChange(val) {
				this.query.page = val
				this.getCouponList();
			},
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
			updateStatus(id) {
				this.$http.get("dCoupon/stop?id=" + id).then(res => {
					if (res.body.code == "200") {
						this.$message.success("停止/开始成功")
					}
					this.getCouponList();
				})
			},
			pagechange() {
				this.query.size = 10
				this.query.page = 1
				this.getCouponList()
			},
			getCouponList() {
				var query = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size + "&overStatus=" + this.query.overStatus +
				 "&name=" + this.query.name;
				if (this.query.status != -1) query += "&status=" + this.query.status;
				if (this.query.type != -1) query += "&type=" + this.query.type;
				this.$http.get("dCoupon/list" + query).then(res => {
					this.couponList = res.body.data;
					var exTmp = []
					this.couponList.forEach(item => {
						item.totalNum = parseInt(item.totalNum)
						item.percentage = parseInt(((item.totalNum - item.getNum) / item.totalNum * 100)
							.toFixed(0))
						if (item.percentage <= 15) {
							exTmp.push(item.title)
						}
					})
					if (exTmp.length > 0) {
						this.$notify({
							title: '以下券码库存低',
							dangerouslyUseHTMLString: true,
							type: 'error',
							message: "优惠券:" + exTmp.join("，") + "<br>库存低，请尽快补充券码</br>",
							duration: 2000
						});
					}
					this.query.page = res.body.pageNum;
					this.query.size = res.body.pageSize;
					this.query.total = res.body.total;
				})
			},
			jump() {
				this.$router.push({
					path: '/newvolumeset',
				})
			},
			//发券包部分
			getMemberDetail() {
				this.$http.get("member/detail?text=显示").then(res => {
					this.memberDetail = res.body.data;
					this.memberDetail.forEach(item =>
						item.name = (item.member == 1 ? "老-" : item.member == 2 ? "新-" : "所有-") + item.name
						// if(item.member == 1){
						// 	item.name = "老"+item.name;
						// }else if(item.member == 2){
						// 	item.name = "新"+item.name;
						// }else{
						// 	item.name = "所有"+item.name;
						// }
					);
				})
			},
			sendCoupon() {
				var tmp = {
					id: this.sendCouponObject.userId,
					keyword: this.sendCouponObject.memberId,
					text: this.sendCouponObject.text
				}
				this.$http.post("dCoupon/sendByMember", JSON.stringify(tmp)).then(res => {
					if (res.body.code == 200) {
						this.$message.success(res.body.data)
						this.sendDialog = false
					} else {
						this.$message.error(res.body.data)
					}
				})
			},
			//检查已经发送的券码有效期是否为空
			checkCouponCode() {
				this.$http.get("dCoupon/checkCouponCode").then(res => {
					if (res.body.data.length > 0) {
						var tmp = []
						res.body.data.forEach(i => {
							tmp.push(i.code)
						})
						this.$notify({
							title: '已领取的券码没有设置有效期',
							dangerouslyUseHTMLString: true,
							type: 'error',
							message: "券码:" + tmp.join("，") + "<br>将导致客户无法使用这些券</br>",
							duration: 0
						});
					}
				})
			},
		},
	};
</script>
<style lang="less" scoped>
	.tanchutitle {
		margin-top: -30px;
		width: 100%;
		height: 42px;
		line-height: 42px;
		background-color: #F2F2F2;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #888888;
		box-sizing: border-box;
		padding-left: 10px;

	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	// 弹出框内容
	.dia_title {
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #525252;
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 
	.boton {
		display: flex;

		>div {
			margin-right: 15px;
			flex-wrap: wrap;

			.boton1_title {
				cursor: pointer;
				height: 32px;
				padding-left: 8px;
				padding-right: 8px;
				border: 1px dashed #D9DCE3;
				border-radius: 4px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				line-height: 32px;
				text-align: center;
			}

			.botonlist {
				margin-top: 15px;
				text-align: center;
				line-height: 32px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				width: 99px;
				height: 32px;
				border: 1px solid #D9DCE3;
				border-radius: 4px;
				position: relative;

				div {
					cursor: pointer;
					line-height: 15px;
					position: absolute;
					width: 16px;
					height: 16px;
					background-color: black;
					color: white;
					border-radius: 50%;
					font-size: 14px;
					right: -8px;
					top: -8px;
				}
			}
		}

	}

	.bon_data {
		display: flex;

		div {
			padding-left: 5px;
			padding-right: 5px;
		}
	}

	.lastbottom {
		width: 138px;
		margin-left: 29%;
		margin-top: 25px;
	}

	.duo {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #959595;
		opacity: 0.51;
		margin-top: -4px;
	}

	.lastdig {
		/deep/.el-dialog__close {
			display: none;
		}

		.mybotton {
			margin-left: 39%;
			margin-top: 15px;
		}
	}
</style>